export default {
    resources: {
        users: {
            name: 'Utilisateur |||| Utilisateurs',
            fields: {
                id: 'Id',
                email: 'Email',
                alias: 'Pseudonyme',
                maritalStatus: 'Situation',
                maleBirthYear: 'Année de naissance homme',
                femaleBirthYear: 'Année de naissance femme',
                language: 'Langue',
                acceptNotifications: 'Accepte les notifications',
                questions: 'Questions',
                questionPool: 'Nombre de question disponible',
                tosAccept: 'CGU acceptés',
                isActive: 'Actif',
            }
        },
        user_answers: {
            name: 'Réponse utilisateur |||| Réponses utilisateurs',
            fields: {
                id: 'Id',
                isFantasy: 'Fantasme',
                isAction: 'Action',
                isSkipped: 'Passée',
                gaugeLevel: 'Jauge',
                user: 'Utilisateur',
                question: 'Question',
                answer: 'Réponse'
            }
        },
        questions: {
            name: 'Question |||| Questions',
            fields: {
                id: 'Id',
                label: 'Libellé',
                complement: 'Complement',
                showFantasy: 'Montrer Fantasme',
                showAction: 'Montrer Action',
                showGauge: 'Montrer Jauge',
                vision: 'Vision',
                notion: 'Notion',
                theme: 'Theme',
                tags: 'Tags',
                pack: 'Thematique',
                answerGroup: 'Groupe de réponses'
            }
        },
        answers: {
            name: 'Réponse |||| Réponses',
            fields: {
                id: 'Id',
                sequence: 'Séquence',
                label: 'Libellé',
                weight: 'Poid',
                group: 'Groupe'
            }
        },
        notion: {
            name: 'Notion |||| Notions',
            fields: {
                id: 'Id',
                label: 'Libellé'
            }
        },
        packs: {
            name: 'Thématique |||| Thématiques',
            fields: {
                id: 'Id',
                label: 'Libellé',
                sequence: 'Sequence'
            }
        },
        tags: {
            name: 'Tag |||| Tags',
            fields: {
                id: 'Id',
                label: 'Libellé'
            }
        },
        themes: {
            name: 'Theme |||| Themes',
            fields: {
                id: 'Id',
                label: 'Libellé'
            }
        },
        visions: {
            name: 'Vision |||| Visions',
            fields: {
                id: 'Id',
                label: 'Libellé'
            }
        },
        answer_groups: {
            name: 'Groupe de réponses |||| Groupes de réponses',
            fields: {
                id: 'Id',
                label: 'Libellé',
                answers: 'Réponses',
                newAnswers: 'Nouvelles Réponses'
            }
        },
        posts: {
            name: 'Post |||| Posts',
            fields: {
                id: 'Id',
                title: 'Titre',
                description: 'Description',
                createDate: 'Date de création',
                updateDate: 'Date de mise-à-jour'
            }
        },
        conditions: {
            name: 'Condition |||| Contitions',
            fields: {
                id: 'Id',
                question: 'Question',
                minWeight: 'Poids minimun',
                maxWeight: 'Poids maximun'
            },
            errors: {
              weight: 'Le poids maximun ne peut pas être supérieur au poids minimun'
            }
        },
        offers: {
            name: 'Offre |||| Offres',
            fields: {
                questionNumber: 'Nombre de questions',
                price: 'Prix',
            }
        }
    },
    dashboard: {
        message: 'Dashboard',
    },
    assignQuestions: {
        title: 'Attribuer des questions à l\'utilisateur %{id}',
        button: 'Attribuer des questions'
    },
    custom: {input: {autocomplete: {none: 'Aucun'}}}
};



// WEBPACK FOOTER //
// ./src/i18n/fr_FR.js